import { Component } from 'react';
import type { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { createLocalizationProvider } from '@mews/framework/localization';
import { localizationMapper } from '../../mappers/localizationMapper';
import type { ApplicationState } from '../../types';

const BaseLocalizationProvider = createLocalizationProvider({
    localizationHandlerNames: [
        'localizeText',
        'localizeProperty',
        'localizeDate',
        'localizeShortDate',
        'localizeShortTime',
        'localizeCurrencyValue',
        'localizePercent',
    ],
});

type BaseLocalizationProps = ComponentProps<typeof BaseLocalizationProvider>;
type LocalizationStateProps = ReturnType<typeof localizationMapper>;
type LocalizationOwnProps = Omit<BaseLocalizationProps, keyof LocalizationStateProps>;
type LocalizationProps = LocalizationStateProps & LocalizationOwnProps;
type LocalizationInstance = InstanceType<typeof BaseLocalizationProvider>;

class LocalizationProviderWrapper extends Component<LocalizationProps> {
    private component: LocalizationInstance | null = null;

    componentDidUpdate(prevProps: LocalizationProps) {
        if (prevProps.currencyCode !== this.props.currencyCode) {
            this.component?.triggerUpdate?.();
        }
    }

    private componentRef = (component: LocalizationInstance | null) => {
        this.component = component;
    };

    render() {
        const { languageCode, currencyCode: _currencyCode, ...props } = this.props;

        return (
            <BaseLocalizationProvider
                ref={this.componentRef}
                languageCode={languageCode as BaseLocalizationProps['languageCode']}
                {...props}
            />
        );
    }
}

export const LocalizationProvider = connect<LocalizationStateProps, {}, LocalizationOwnProps, ApplicationState>(
    localizationMapper
)(LocalizationProviderWrapper);
